<template>
  <div class="transfer">
    <div class="duration d-flex flex-column">
      <time-duration
        v-if="transferDuration"
        class="duration"
        :duration="transferDuration"
      ></time-duration>
    </div>

    <div class="transfer-line-container">
      <div class="transfer-line"></div>
    </div>

    <div class="score my-2" v-if="transfer.transferScore !== undefined">
      Anschluss:
      <transfer-score
        :score="transfer.transferScore"
        :inline="true"
        class="px-2 py-1 rounded border"
      ></transfer-score>
    </div>

    <needed-transfer-duration class="my-2" :transfer="transfer" />

    <div class="walk my-2" v-if="transfer.distanceMeters">
      <i class="icon icon-person-walking-solid"></i>
      {{ Math.round(transfer.distanceMeters) }} m Fußweg
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import dayjs from 'dayjs'
import TimeDuration from '~/components/TimeDuration.vue'
import NeededTransferDuration from '~/components/JourneyDisplay/NeededTransferDuration.vue'
import { type Transfer, type Leg } from '~/types/fptfTypes'
import TransferScore from '~/components/JourneyDisplay/TransferScore.vue'

const props = defineProps<{
  transfer: Transfer
  previousLeg?: Leg
  nextLeg?: Leg
}>()
const transferDuration = computed(() => {
  return dayjs.duration(dayjs(props.nextLeg?.departure).diff(props.previousLeg?.arrival))
})
</script>

<style lang="scss">
.transfer {
  display: grid;
  gap: 5px;
  padding: 15px;
  grid-template-columns: $time_col_width $fancy_line_width 1fr;
  grid-template-areas:
    'duration fancy-line score'
    'duration fancy-line min-transfer-duration'
    'duration fancy-line walk';
}

.transfer-line-container {
  grid-area: fancy-line;
  display: flex;
  justify-content: center;
}

.transfer-line {
  border: 1px dashed $gray-500;
  align-self: center;
  z-index: 1;
  height: calc(100% + 16ch);
}

.walk {
  grid-area: walk;
}
</style>
